//@flow

import React, { lazy } from 'react';
import i18n from 'app/common/lib/i18n';
import SafeSuspense from 'app/packages/safe-suspense';
import { type SendObjectWrapperProps } from 'app/common/react/components/sending/SendObjectWrapper';
import { Box, Spinner } from 'gestalt';

const SendObjectWrapper = lazy(() =>
  import(/* webpackChunkName: "SendObjectWrapperCommon" */ 'app/common/react/components/sending/SendObjectWrapper'),
);

export default function SendObjectLoader(props: SendObjectWrapperProps) {
  return (
    <SafeSuspense
      fallback={
        <Box display="flex" alignItems="center" justifyContent="center" width="100%" padding={2}>
          <Spinner
            accessibilityLabel={i18n._(
              'Loading sharing',
              'Accessibility label for loading sharing UI',
            )}
            show
          />
        </Box>
      }
    >
      <SendObjectWrapper {...props} />
    </SafeSuspense>
  );
}
